import api from "../utils/axios";

export const getMigrationStatus = () =>
  api.get("/admin/migrations/status");

export const runMigrations = (migrations = ["all"]) =>
  api.post("/admin/migrations/run", { migrations });
